import React from "react";
import icon_loading_data from "./circle_loading_primary.json";
import SSRLottie from "./SSRLottie";

type LoadingAnimationType = {
  width?: number;
};

// 보라색 로딩이 돌아가는 모양
const LoadingAnimation = (props: LoadingAnimationType) => {
  const { width } = props;
  return (
    <div>
      <SSRLottie animationData={icon_loading_data} style={{ width: width ?? 60 }} />
    </div>
  );
};

export { LoadingAnimation };
